(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nyvolt-brand-marquee"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nyvolt-brand-marquee')) {
    customElements.define('nyvolt-brand-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.hasAttribute('data-ready')) return;
        this.addEventListener('focusin', (event) => {
          const link = event.target.closest('.nv-brand-marquee__group:not([aria-hidden]) a');
          if (link && link.matches(':focus-visible')) {
            requestAnimationFrame(() => link.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'instant' }));
          }
        });
        this.setAttribute('data-ready', '');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nyvolt-purchase-summary"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nyvolt-purchase-summary')) {
  customElements.define('nyvolt-purchase-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.product = this.closest('rv-product,nyvolt-yvolt');
      if (!this.product) return;
      this.events = new AbortController();
      const options = {signal:this.events.signal};
      const refresh = () => {
        if (this.pending) return;
        this.pending = true;
        this.frame = requestAnimationFrame(() => { this.pending = false; if (this.isConnected) this.update(); });
      };
      this.product.addEventListener('ryvolt:variant', refresh, options);
      this.product.addEventListener('ryvolt:finish', refresh, options);
      this.product.addEventListener('click', event => {
        if (event.target.closest('[data-variant],[data-color-preview],[data-yv-variant],[data-usage]')) refresh();
      }, options);
      window.addEventListener('popstate', refresh, options);
      refresh();
    }
    update() {
      const root = this.product;
      const chosen = root.querySelector('[data-variant][aria-current="true"],[data-yv-variant][aria-pressed="true"],[data-color-preview][aria-pressed="true"]');
      const colour = chosen?.dataset.label || chosen?.dataset.finishName || root.querySelector('[data-color-name],[data-preview-color-name],[data-yv-colour-label]')?.textContent.trim();
      const cell = this.querySelector('[data-summary-colour]');
      if (colour) { cell.textContent = colour; cell.parentElement.hidden = false; this.querySelector('a').hidden = false; }
      const price = root.querySelector('.rv-product__price-row [data-price],[data-yv-price]');
      if (price) this.querySelector('[data-summary-price]').textContent = price.textContent.trim();
      const version = this.querySelector('[data-summary-version]');
      const mode = root.querySelector('[data-usage][aria-pressed="true"] strong');
      if (version && mode) version.textContent = mode.textContent.trim();
    }
    disconnectedCallback() { this.events?.abort(); cancelAnimationFrame(this.frame); this.pending = false; this.events = null; }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nyvolt-scooter-tabs"] && !Shopify.designMode) return;
  try {
    (() => {
  function mount(root) {
    if (root.dataset.tabsReady) return;
    const nav = root.querySelector('[data-tabs-nav]');
    const tabs = Array.from(nav.querySelectorAll('[data-product-tab]'));
    const panels = tabs.map(tab => document.getElementById(tab.hash.slice(1)));
    if (!tabs.length || panels.some(panel => !panel)) return;
    root.dataset.tabsReady = 'true';
    nav.setAttribute('role', 'tablist');
    function select(index, focus, updateHash) {
      tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        panels[i].hidden = !selected;
        panels[i].querySelectorAll('iframe[data-product-video-src]').forEach(frame => {
          if (selected && !frame.hasAttribute('src')) frame.src = frame.dataset.productVideoSrc;
          else if (!selected && frame.hasAttribute('src')) frame.removeAttribute('src');
        });
        if (!selected) panels[i].querySelectorAll('video').forEach(video => video.pause());
      });
      const navBounds = nav.getBoundingClientRect();
      const tabBounds = tabs[index].getBoundingClientRect();
      if (tabBounds.left < navBounds.left) nav.scrollLeft += tabBounds.left - navBounds.left;
      else if (tabBounds.right > navBounds.right) nav.scrollLeft += tabBounds.right - navBounds.right;
      if (focus) {
        tabs[index].focus({preventScroll:true});
        tabs[index].scrollIntoView?.({block:'nearest',inline:'nearest',behavior:'instant'});
      }
      if (updateHash) {
        const url = new URL(window.location.href);
        url.hash = tabs[index].hash;
        window.history.replaceState({}, '', url);
      }
    }
    tabs.forEach((tab, index) => {
      tab.setAttribute('role', 'tab');
      tab.setAttribute('aria-controls', panels[index].id);
      panels[index].setAttribute('role', 'tabpanel');
      panels[index].setAttribute('aria-labelledby', tab.id);
      panels[index].tabIndex = 0;
      tab.addEventListener('click', event => {
        event.preventDefault();
        select(index, false, true);
        (root.classList.contains('nv-product-tabs--moto') ? nav : panels[index]).scrollIntoView?.({block:'start',behavior:'instant'});
      });
      tab.addEventListener('keydown', event => {
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        else if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        else if (event.key !== ' ') return;
        event.preventDefault(); select(next, true, true);
      });
    });
    function fromHash() {
      const hash = window.location.hash;
      const match = tabs.findIndex(tab => tab.hash === hash);
      select(match >= 0 ? match : hash === '#caracteristiques-dualtron' ? 1 : 0, false, false);
    }
    window.addEventListener('hashchange', fromHash);
    const productScope = root.closest('[data-dualtron-product]') || root;
    productScope.addEventListener('click', event => {
      const link = event.target.closest('[data-product-details-link]');
      if (!link) return;
      const index = tabs.findIndex(tab => tab.hash === link.hash);
      if (index < 0) return;
      event.preventDefault();
      select(index, false, true);
      panels[index].scrollIntoView?.({block:'start',behavior:window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      panels[index].focus({preventScroll:true});
    });
    fromHash();
  }
  function mountAll(scope = document) { scope.querySelectorAll('[data-product-tabs]').forEach(mount); }
  mountAll();
  document.addEventListener('shopify:section:load', event => mountAll(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
